import React from 'react';
import { SlidersHorizontal } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Checkbox } from '@/components/ui/checkbox';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Separator } from '@/components/ui/separator';
const DEVICE_OPTIONS = [
    { value: 'mobile', label: 'Mobile' },
    { value: 'iphone', label: 'iPhone' },
    { value: 'ipad', label: 'iPad' },
    { value: 'android', label: 'Android' },
    { value: 'desktop', label: 'Desktop' },
    { value: 'macintosh', label: 'Macintosh' },
    { value: 'tablet', label: 'Tablet' },
    { value: 'bot', label: 'Bot' },
    { value: 'other', label: 'Other' },
    { value: 'unknown', label: 'Unknown' },
];
const BROWSER_OPTIONS = [
    { value: 'chrome', label: 'Chrome' },
    { value: 'safari', label: 'Safari' },
    { value: 'firefox', label: 'Firefox' },
    { value: 'edge', label: 'Edge' },
    { value: 'opera', label: 'Opera' },
    { value: 'facebook', label: 'Facebook' },
    { value: 'instagram', label: 'Instagram' },
    { value: 'tiktok', label: 'TikTok' },
    { value: 'twitter', label: 'Twitter' },
    { value: 'linkedin', label: 'LinkedIn' },
    { value: 'reddit', label: 'Reddit' },
    { value: 'whatsapp', label: 'WhatsApp' },
    { value: 'telegram', label: 'Telegram' },
    { value: 'messenger', label: 'Messenger' },
    { value: 'pinterest', label: 'Pinterest' },
    { value: 'bot', label: 'Bot' },
    { value: 'unknown', label: 'Unknown' },
];
export function AnalyticsFilter({ excludeDevices, excludeBrowsers, onDevicesChange, onBrowsersChange, }) {
    const activeCount = excludeDevices.length + excludeBrowsers.length;
    const toggleDevice = React.useCallback((value) => {
        const next = excludeDevices.includes(value)
            ? excludeDevices.filter((v) => v !== value)
            : [...excludeDevices, value];
        onDevicesChange(next);
    }, [excludeDevices, onDevicesChange]);
    const toggleBrowser = React.useCallback((value) => {
        const next = excludeBrowsers.includes(value)
            ? excludeBrowsers.filter((v) => v !== value)
            : [...excludeBrowsers, value];
        onBrowsersChange(next);
    }, [excludeBrowsers, onBrowsersChange]);
    const clearAll = React.useCallback(() => {
        onDevicesChange([]);
        onBrowsersChange([]);
    }, [onDevicesChange, onBrowsersChange]);
    return (<Popover>
            <PopoverTrigger asChild>
                <Button variant="outline" size="sm" className="relative gap-1.5">
                    <SlidersHorizontal className="h-3.5 w-3.5"/>
                    <span>Filter</span>
                    {activeCount > 0 && (<Badge variant="secondary" className="ml-0.5 h-5 min-w-5 px-1 text-[10px]">
                            {activeCount}
                        </Badge>)}
                </Button>
            </PopoverTrigger>

            <PopoverContent align="end" className="w-72 p-4">
                <div className="flex items-center justify-between mb-3">
                    <p className="text-sm font-semibold">Exclude from charts</p>
                    {activeCount > 0 && (<button onClick={clearAll} className="text-xs text-muted-foreground hover:text-foreground">
                            Clear all
                        </button>)}
                </div>

                {/* Device types */}
                <p className="mb-2 text-xs font-medium uppercase tracking-widest text-muted-foreground">Device types</p>
                <div className="grid grid-cols-2 gap-y-2 gap-x-3">
                    {DEVICE_OPTIONS.map(({ value, label }) => (<label key={value} className="flex cursor-pointer items-center gap-2 text-sm">
                            <Checkbox checked={excludeDevices.includes(value)} onCheckedChange={() => toggleDevice(value)}/>
                            {label}
                        </label>))}
                </div>

                <Separator className="my-4"/>

                {/* Browser types */}
                <p className="mb-2 text-xs font-medium uppercase tracking-widest text-muted-foreground">
                    Browser / app
                </p>
                <div className="grid grid-cols-2 gap-y-2 gap-x-3">
                    {BROWSER_OPTIONS.map(({ value, label }) => (<label key={value} className="flex cursor-pointer items-center gap-2 text-sm">
                            <Checkbox checked={excludeBrowsers.includes(value)} onCheckedChange={() => toggleBrowser(value)}/>
                            {label}
                        </label>))}
                </div>
            </PopoverContent>
        </Popover>);
}
